var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55633 1.09067H9.896L5.391 14.4385C5.3447 14.5757 5.25655 14.6948 5.13896 14.7793C5.02137 14.8637 4.88026 14.9091 4.7355 14.9092H1.35817C1.24848 14.9092 1.14037 14.8831 1.04278 14.833C0.945191 14.783 0.860921 14.7104 0.796945 14.6213C0.732968 14.5322 0.691125 14.4292 0.674875 14.3207C0.658626 14.2122 0.668437 14.1014 0.703499 13.9975L4.90066 1.56133C4.94695 1.42412 5.03511 1.30488 5.15274 1.22041C5.27036 1.13595 5.41152 1.09067 5.55633 1.09067Z",
    fill: "url(#paint0_linear_117_2898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8625 10.0435H4.98084C4.91686 10.0434 4.85434 10.0626 4.80143 10.0986C4.74852 10.1346 4.70767 10.1856 4.6842 10.2452C4.66072 10.3047 4.65572 10.3699 4.66984 10.4323C4.68395 10.4947 4.71654 10.5514 4.76334 10.595L9.18534 14.7223C9.31409 14.8424 9.48361 14.9092 9.65967 14.9092H13.5563L11.8625 10.0435Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55633 1.09067C5.40994 1.09011 5.26721 1.13637 5.14897 1.2227C5.03074 1.30903 4.94321 1.4309 4.89917 1.57051L0.708668 13.9862C0.671248 14.0905 0.6595 14.2023 0.674418 14.3121C0.689336 14.4219 0.730481 14.5265 0.794372 14.617C0.858264 14.7075 0.943022 14.7814 1.04148 14.8322C1.13993 14.8831 1.24919 14.9095 1.36 14.9092H4.8245C4.95353 14.8861 5.07414 14.8292 5.17399 14.7443C5.27384 14.6594 5.34936 14.5495 5.39283 14.4258L6.2285 11.963L9.2135 14.7472C9.33859 14.8506 9.49551 14.9078 9.65784 14.9092H13.54L11.8373 10.0435L6.87383 10.0447L9.91167 1.09067H5.55633Z",
    fill: "url(#paint1_linear_117_2898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0992 1.56067C11.053 1.42367 10.9649 1.30463 10.8475 1.22031C10.73 1.136 10.5891 1.09065 10.4445 1.09067H5.608C5.75258 1.09068 5.89351 1.13603 6.01095 1.22035C6.12839 1.30466 6.21643 1.42369 6.26267 1.56067L10.46 13.9973C10.4951 14.1013 10.5049 14.2121 10.4887 14.3206C10.4725 14.4291 10.4306 14.5322 10.3666 14.6213C10.3027 14.7104 10.2184 14.783 10.1208 14.8331C10.0232 14.8832 9.91504 14.9093 9.80534 14.9093H14.642C14.7517 14.9093 14.8598 14.8832 14.9574 14.8331C15.055 14.783 15.1392 14.7103 15.2032 14.6212C15.2671 14.5321 15.309 14.429 15.3252 14.3205C15.3414 14.2121 15.3316 14.1013 15.2965 13.9973L11.0992 1.56067Z",
    fill: "url(#paint2_linear_117_2898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_2898",
    x1: 7.138,
    y1: 2.11467,
    x2: 2.63116,
    y2: 15.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_2898",
    x1: 8.54583,
    y1: 8.31951,
    x2: 7.50333,
    y2: 8.67201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_2898",
    x1: 7.9725,
    y1: 1.72633,
    x2: 12.9197,
    y2: 14.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAzure);
export default __webpack_public_path__ + "static/media/Logo_azure.946b053320a83a62d9ea8a377ddba8bb.svg";
export { ForwardRef as ReactComponent };